export default __webpack_public_path__ + "static/media/tmp_travel_image.1f1071b1.png";